import breakText from 'utils/breakText';

export default (text, keywords, addingChar = '__') => {
  const keywordInText = {
    text: '',
    word: ''
  };

  const splittedText = breakText(text);

  const splittedTextInLowerCase = breakText(text.toLowerCase());

  keywords.forEach(keyword => {
    if (!keywordInText.word) {
      const keywordIncludedText = splittedTextInLowerCase.find(text => {
        if (!text.includes('__') && text.startsWith(keyword)) {
          return text;
        }
      });

      const keywordInTextIndex = !!keywordIncludedText
        ? splittedTextInLowerCase.indexOf(keywordIncludedText)
        : splittedTextInLowerCase.indexOf(keyword);
      if (keywordInTextIndex > -1) {
        const selectedKeywordInText = splittedText[keywordInTextIndex];
        splittedText.splice(
          keywordInTextIndex,
          1,
          addingChar + selectedKeywordInText + addingChar
        );
        keywordInText.word = keyword;
      }
    }
  });

  keywordInText.text = splittedText.join('');

  return keywordInText;
};
